import React, { useEffect, useState } from 'react';
import '../styles/PageTransition.css';
import LoadingSpinner from './LoadingSpinner';

const PageTransition = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    // Function to check if all images and resources are loaded
    const checkIfLoaded = () => {
      if (!mounted) return;

      const images = document.querySelectorAll('img');
      const loadedImages = Array.from(images).filter(img => img.complete);
      
      if (loadedImages.length === images.length) {
        setIsLoading(false);
        setIsVisible(true);
      } else {
        // If not all images are loaded, check again in a moment
        requestAnimationFrame(checkIfLoaded);
      }
    };

    // Start checking for loaded resources
    checkIfLoaded();

    return () => {
      mounted = false;
    };
  }, [children]);

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <div className={`page-transition ${isVisible ? 'visible' : ''}`}>
        {children}
      </div>
    </>
  );
};

export default PageTransition;
